export default __webpack_public_path__ + "static/media/logo-all-white.f3ab13fc.svg";